import { render, staticRenderFns } from "./SubscriptionBtn.vue?vue&type=template&id=5828be87&scoped=true"
import script from "./SubscriptionBtn.vue?vue&type=script&lang=js"
export * from "./SubscriptionBtn.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionBtn.vue?vue&type=style&index=0&id=5828be87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5828be87",
  null
  
)

export default component.exports